import _objectAssign from './_objectAssign';

export default typeof Object.assign === 'function' ? Object.assign : _objectAssign;


//////////////////
// WEBPACK FOOTER
// /app/node_modules/ramda/es/internal/_assign.js
// module id = 127
// module chunks = 0